<template>
  <CompanyTemplate>
    <b-loading :is-full-page="true" :active.sync="isLoadingPage"></b-loading>
    <contentprofile @closeLoading="closeLoadingFunc" />
  </CompanyTemplate>
</template>

<script>
  import CompanyTemplate from '../template/CompanyTemplate'
import { mapState } from "vuex";
import navbarmentor from './navbarmentor'
import contentprofile from '../components/contentprofile'
export default {
  components:{
    navbarmentor,
    contentprofile,
    CompanyTemplate
  },
  data(){
    return{
      isLoadingPage:true
    }
  },
  methods:{
    closeLoadingFunc(){
      console.log('reighnldsmvn;lawd;asdk;lsdk;l')
      setTimeout(()=>{
        this.isLoadingPage = false
      },1000)
      
    }
  },
  computed: {
         ...mapState(["profilemenumargin"]),
    },
      mounted(){
      }
};
</script>
<style scoped>
/* .marginmenucontainer{
      max-width: calc(100vw - 400px);
    width: calc(100vw - 400px);
} */
.background{
    min-height: 100vh;
    overflow: hidden;
    background-color: #F4F4F4 !important;
    transition: 0.5s all;
}
.marginmenu{
  margin-right:400px
}
@media screen and (min-width: 1088px){
.container {
    max-width: calc(98vw - 400px);
    width: calc(98vw - 400px);
}
}
@media screen and (min-width: 1280px){
.container {
    max-width: calc(98vw - 400px);
    width: calc(98vw - 400px);
}
}

@media only screen and (max-width: 1087px) {
  .container{
    padding:5px
  }
} 

@media only screen and (max-width: 769px) {
  .container{
    padding:5px
  }
} 
@media only screen and (max-width: 760px) {
  .marginmenu{
    margin-right: 0px !important
  }
} 



</style>